import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, BookOpen, MessageSquare, Anchor, Map } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <BookOpen className="w-6 h-6 text-terracotta" data-id="element-156" />,
    title: "El Manual Completo 'Sintonía Total'",
    description: 'En formato PDF (0 a 5 años). Tu guía de cabecera para cada etapa.'
  }, {
    icon: <MessageSquare className="w-6 h-6 text-terracotta" data-id="element-157" />,
    title: 'Diccionario de Crisis',
    description: 'Qué dice tu hijo vs. Qué necesita realmente. Aprende a traducir sus emociones.'
  }, {
    icon: <CheckCircle2 className="w-6 h-6 text-terracotta" data-id="element-158" />,
    title: 'Guiones de Acción Rápida',
    description: 'Frases exactas para detener el caos en 10 segundos sin perder la conexión.'
  }, {
    icon: <Anchor className="w-6 h-6 text-terracotta" data-id="element-159" />,
    title: 'Técnica del Ancla',
    description: 'Un método de 60 segundos para recuperar tu calma antes de reaccionar.'
  }, {
    icon: <Map className="w-6 h-6 text-terracotta" data-id="element-160" />,
    title: 'Mapa de Hitos Emocionales',
    description: 'Sabrás qué cambio viene antes de que suceda para estar siempre preparada.'
  }];
  return <section className="py-20 bg-white" data-id="element-161">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-162">
        <FadeIn data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brown mb-16" data-id="element-164">
            ¿Qué incluye Sintonía Total?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-165">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === 0 ? 'md:col-span-2 lg:col-span-3' : ''} data-id="element-166">
              <div className={`bg-cream/30 p-8 rounded-2xl border border-cream-dark h-full transition-all hover:shadow-md hover:bg-cream/50 ${index === 0 ? 'flex flex-col md:flex-row items-center text-center md:text-left gap-6 lg:w-2/3 lg:mx-auto' : ''}`} data-id="element-167">
                <div className="w-14 h-14 rounded-full bg-white flex items-center justify-center shadow-sm flex-shrink-0 mb-6 md:mb-0" data-id="element-168">
                  {item.icon}
                </div>
                <div data-id="element-169">
                  <h3 className="text-xl font-bold text-brown mb-2 font-serif" data-id="element-170">
                    {item.title}
                  </h3>
                  <p className="text-brown-light" data-id="element-171">{item.description}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}